import {
  Box,
  Button,
  Card,
  Checkbox,
  Container,
  FormControl,
  FormLabel,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import imageCompression from 'browser-image-compression';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';
import InfoTooltip from '../InfoTooltip';
import { createRefill, createAroundUs, createQuestion, getBnbList, uploadFile } from '../../helper/backend_helper';

const AddRefillItems = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ profileImage: null });
  const [name, setName] = useState('');
  const [italianName, setItalianName] = useState('');

  const [loading, setLoading] = useState(false);
  const handleFileChange = (e) => {
    const { name, files } = e.target;

    setFormData({
      ...formData,
      [name]: files[0],
    });
  };

  const [users, setUsers] = useState([]);
  console.log('users', users);
  async function fetchData() {
    try {
      const usersResponse = await getBnbList();
      setUsers(usersResponse?.data?.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  const handleSave = async () => {
    try {
      setLoading(true);

      if (!name) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Name is required',
        });
        setLoading(false);
        return;
      }
      if (!italianName) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Italian Name is required',
        });
        setLoading(false);
        return;
      }

      if (!formData.profileImage) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Image is required',
        });
        setLoading(false);
        return;
      }

      // Prepare headers for multipart form data
      const headers = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      const originalFile = formData.profileImage;

      // Log original file size
      console.log('Original file size:', (originalFile.size / 1024).toFixed(2), 'KB');

      // Compression options
      const options = {
        maxSizeMB: 0.3, // Compress to a maximum of 0.5 MB
        maxWidthOrHeight: 800, // Restrict dimensions to 800px
        useWebWorker: true, // Use web worker for performance
        initialQuality: 0.6, // Reduce starting quality to 60%
      };

      // Compress image
      const compressedFile = await imageCompression(originalFile, options);

      // Log compressed file size
      console.log('Compressed file size:', (compressedFile.size / 1024).toFixed(2), 'KB');
      const data = new FormData();
      data.append('file', compressedFile);

      const imageUploadResponse = await uploadFile(data, headers);
      console.log(imageUploadResponse?.data?.data?.fileName);

      if (imageUploadResponse.status !== 200) {
        throw new Error('Image upload failed');
      }

      const Categorydata = {
        name,
        italianName,
        image: imageUploadResponse?.data?.data?.fileName,
      };
      console.log(Categorydata);
      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createRefill(Categorydata, Categoryheaders);

      setFormData({
        ...formData,
        profileImage: null,
      });

      // Show success message
      Swal.fire({
        icon: 'success',
        title: 'Refill Items created successfully',
      });
      setName('');
      setItalianName('');

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: `${error?.response?.data?.errors[0]?.message}`,
      });
    }
  };

  return (
    <>
      <Helmet>
        <title> Add Refill Items </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack
          onClick={() => navigate(-1)}
          gap={3}
          sx={{ cursor: 'pointer', mb: 3 }}
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
        >
          <FaArrowLeftLong size={24} />
          <Typography variant="h4">Add Refill Items</Typography>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 2 }}>
            <FormLabel sx={{ mb: 1 }}>Name <InfoTooltip title="English name of the refill consumable (e.g. coffee, soap) guests can request to be restocked." /></FormLabel>
            <TextField
              label="Enter Name"
              id="outlined-size-small"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </Stack>

          <Stack sx={{ width: { xs: '100%', sm: '45%' }, mt: 2 }}>
            <FormLabel sx={{ mb: 1 }}>Italian Name <InfoTooltip title="Italian translation of the item name, shown to guests browsing the app in Italian." /></FormLabel>
            <TextField
              label="Enter Italian Name"
              id="outlined-size-small"
              value={italianName}
              onChange={(e) => setItalianName(e.target.value)}
            />
          </Stack>

          <Stack
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 2,
              marginTop: 2,
            }}
          >
            <Stack>
              {formData.profileImage && (
                <img
                  src={URL.createObjectURL(formData.profileImage)}
                  alt="img"
                  style={{ maxWidth: '300px', borderRadius: 10 }}
                />
              )}
            </Stack>
            <Button
              sx={{
                width: 170,
                color: '#1E3A5F',
                borderColor: '#1E3A5F',
                '&:hover': {
                  borderColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              component="label"
              variant="outlined"
              size="medium"
              startIcon={<SlCloudUpload />}
            >
              upload Image
              <input
                type="file"
                accept="image/*"
                name="profileImage"
                style={{ display: 'none' }}
                onChange={handleFileChange}
              />
            </Button>
          </Stack>
        </Box>
        <LoadingButton
          sx={{
            width: 100,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Save
        </LoadingButton>
      </Card>
    </>
  );
};

export default AddRefillItems;
